<template>
  <div class="invoice-box">
    <header>
      <h1 class="shop-name">Nokor Shop</h1>
    </header>

    <div class="meta-info">
      <div class="meta-left">
        <div class="meta-row">
          <span class="meta-label">អតិថិជន</span>
          <span class="meta-value">{{ order.shippingDetail && order.shippingDetail.name }}</span>
        </div>
        <div class="meta-row">
          <span class="meta-label">ទូរស័ព្ទ</span>
          <span class="meta-value">{{ order.shippingDetail && order.shippingDetail.phoneNumber }}</span>
        </div>
        <div class="meta-row">
          <span class="meta-label">លេខបុង</span>
          <span class="meta-value">{{ order.orderId }}</span>
        </div>
        <div class="meta-row">
          <span class="meta-label">ទីតាំង</span>
          <span class="meta-value">{{ order.shippingDetail && order.shippingDetail.address }}</span>
        </div>
      </div>

      <div class="meta-right">
        <div class="meta-right-row">
          <span class="meta-right-label">កាលបរិច្ឆេទ</span>
          <span class="date-value">{{ createdAt }}</span>
        </div>
        <div class="meta-right-row">
          <span class="meta-right-label">ទូរស័ព្ទហាង</span>
          <span class="meta-right-value-bold">{{
            order.salePerson && order.salePerson.phoneNumber
              ? order.salePerson.phoneNumber
              : "078 890 101"
          }}</span>
        </div>
      </div>
    </div>

    <table>
      <thead>
        <tr>
          <th style="width: 35px;">ល.រ</th>
          <th style="width: 50px;">រូបភាព</th>
          <th>ឈ្មោះទំនិញ</th>
          <th style="width: 40px;">ចំនួន</th>
          <th style="width: 70px;">តម្លៃរាយ</th>
          <th style="width: 80px;">តម្លៃសរុប</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in order.orderItems" :key="index">
          <td>{{ index + 1 }}</td>
          <td>
            <div class="product-img-container">
              <img
                :src="
                  item.product.mainImage &&
                  (item.product.mainImage.includes('http') || item.product.mainImage.includes('data:image'))
                    ? item.product.mainImage
                    : `${API_URL}/${item.product.mainImage}`
                "
                class="product-img"
                alt="product"
              />
            </div>
          </td>
          <td class="col-name">
            <div class="product-name">{{ item.product.name }}</div>
            <div
              v-for="variation in item.product.variations"
              :key="variation.name"
              class="variation-text"
            >
              {{ variation.name }}: {{ variation.data && variation.data[0] ? variation.data[0].value : 'N/A' }}
            </div>
          </td>
          <td>{{ item.amount || 0 }}</td>
          <td>$ {{ getItemPrice(item).toFixed(2) }}</td>
          <td>$ {{ (getItemPrice(item) * (item.amount || 0)).toFixed(2) }}</td>
        </tr>
      </tbody>
    </table>

    <div class="footer">
      <div class="footer-left">
          <div class="qr-section">
              <div class="qr-container">
                  <img src="../../assets/khqr.jpg" alt="QR Code">
              </div>
              <div class="qr-shop-name">NOKOR SHOP</div>
          </div>
      </div>

      <div class="footer-right">
        <table class="totals-table">
          <tr>
            <td class="label">សរុបថ្លៃទំនិញ</td>
            <td class="amount-cell"><span class="amount-container">$ {{ (total_product_price || 0).toFixed(2) }}</span></td>
          </tr>
          <tr>
            <td class="label">ថ្លៃដឹក</td>
            <td class="amount-cell"><span class="amount-container">$ {{ (order.localDeliveryCost || 0).toFixed(2) }}</span></td>
          </tr>
          <tr v-if="order.discountAmount">
            <td class="label">បញ្ចុះតម្លៃ</td>
            <td class="amount-cell"><span class="amount-container">$ {{ (order.discountAmount || 0).toFixed(2) }}</span></td>
          </tr>
          <tr>
            <td class="label grand-total">ទឹកប្រាក់ត្រូវបង់</td>
            <td class="amount-cell"><span class="amount-container grand-total">$ {{ (total || 0).toFixed(2) }}</span></td>
          </tr>
        </table>

        <div class="terms-section">
          <div class="terms-title">- កំណត់ចំណាំ :</div>
          <div class="terms-list">
            <div>1. ទំនិញទិញហើយមិនអាចប្តូរវិញ ឬដកប្រាក់វិញបានទេ</div>
            <div>2. សូមពិនិត្យផ្ទៀងផ្ទាត់ទំនិញឲ្យច្បាស់មុនពេលអ្នកដឹកចេញ</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Hidden payment images -->
    <div style="display: none;">
      <img
        v-for="(image, index) in order.paymentImages"
        :key="index"
        :src="`${API_URL}/${image.image}`"
        alt=""
      />
    </div>
  </div>
</template>

<script>
require("lity");
import { API_URL } from "../../const";
import moment from "moment";
import _ from "lodash";

export default {
  data() {
    return {
      isLoading: true,
      API_URL: API_URL,
    };
  },

  mounted: function () {
    setTimeout(() => {
      window.print();
    }, 2000);

    window.addEventListener("afterprint", (event) => {
      this.$router.back();
    });
  },

  async created() {
    await this.getOrderDetails();
    if (this.order && this.order.transaction) {
      await this.getTransactionDetails(this.order.transaction);
    }
  },
  methods: {
    async getOrderDetails() {
      await this.$store.dispatch("orderModule/getOrderDetails", {
        _id: this.orderId,
      });
      this.isLoading = false;
    },
    async getTransactionDetails(transactionId) {
      if (transactionId) {
        await this.$store.dispatch("transactionsModule/getTransactionDetails", {
          _id: transactionId,
        });
        this.isLoading = false;
      }
    },
    getItemPrice(item) {
      if (item.price !== undefined && item.price !== null) return item.price;
      if (item.product && item.product.price && item.product.price.maxPrice !== undefined) {
        return item.product.price.maxPrice;
      }
      return 0;
    }
  },
  computed: {
    createdAt() {
      return this.order && this.order.createdAt ? moment(this.order.createdAt).format("DD / MM / YYYY") : "25 / 07 / 2025";
    },
    orderId() {
      return this.$route.params.id;
    },
    order() {
      return this.$store.state.orderModule.orderDetails || {};
    },
    transaction() {
      return this.$store.state.transactionsModule.transactionDetails || {};
    },
    notRefundItems() {
      return this.order.orderItems ? this.order.orderItems.filter(o => o.status !== 9) : [];
    },
    total_product_price() {
      return _.sumBy(this.notRefundItems, (o) => {
        const price = this.getItemPrice(o);
        const amount = o.amount || 0;
        const refundAmount = o.refundAmount || 0;
        return price * (amount - refundAmount);
      }) || 0;
    },
    total_china_fee() {
      return _.sumBy(this.notRefundItems, (o) => {
        return o.chinaDeliveryCost || 0;
      }) || 0;
    },
    insurance() {
      return this.order.insurance ? this.total_product_price * 0.05 : 0;
    },
    total() {
      return (
        (this.total_product_price || 0) +
        (this.insurance || 0) +
        (this.total_china_fee || 0) +
        (this.order.localDeliveryCost || 0) +
        (this.order.internationalShippingCost || 0) -
        (this.order.discountAmount || 0)
      );
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Battambang:wght@400;700&display=swap');

* {
  font-family: 'Battambang', cursive;
  box-sizing: border-box;
  -webkit-print-color-adjust: exact;
}

.invoice-box {
  font-family: 'Battambang', cursive;
  width: 148mm;
  min-height: 210mm;
  padding: 12mm;
  margin: 20px auto;
  background: white;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  position: relative;
  display: flex;
  flex-direction: column;
  font-size: 11px;
  color: #222;
}

@media print {
  body {
    background: #fff;
    padding: 0;
    margin: 0;
  }
  .invoice-box {
    margin: 0;
    box-shadow: none;
    width: 148mm;
    height: 210mm;
    padding: 10mm;
  }
  @page {
    size: A5 portrait;
    margin: 0;
  }
}

header {
  text-align: center;
  margin-bottom: 25px;
}

.shop-name {
  color: #e34133;
  font-size: 38px;
  font-weight: 700;
  margin: 0;
  letter-spacing: 0.5px;
}

.meta-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  line-height: 1.8;
}

.meta-left {
  width: 60%;
}

.meta-right {
  width: 35%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.meta-row {
  display: flex;
  margin-bottom: 4px;
}

.meta-label {
  display: inline-block;
  width: 60px;
  font-weight: 600;
}

.meta-value {
  flex: 1;
  font-weight: 600;
  border-bottom: 1px dotted #ccc;
  padding-left: 5px;
  min-height: 1.2em;
}

.meta-right-label {
  margin-right: 8px;
  font-weight: 600;
  white-space: nowrap;
}

.date-value {
  font-weight: 700;
}

.meta-right-value-bold {
  font-weight: 700;
}

.meta-right-row {
  margin-bottom: 6px;
  display: flex;
  justify-content: flex-start;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 15px;
}

th,
td {
  border: 1px solid #444;
  padding: 6px 4px;
  text-align: center;
  vertical-align: middle;
}

th {
  background-color: #fff;
  font-weight: 700;
  font-size: 11px;
}

.col-name {
  text-align: left;
  padding-left: 10px;
  width: 45%;
}

.product-name {
  font-weight: 600;
  font-size: 10px;
  margin-bottom: 2px;
}

.variation-text {
  font-size: 9px;
  color: #666;
  line-height: 1.2;
}

.product-img-container {
  width: 32px;
  height: 32px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.footer {
  display: flex;
  justify-content: space-between;
}

.footer-left {
  width: 35%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

/* UPDATED QR STYLING */
.qr-section {
    text-align: center;
    width: 140px;
    /* Ensure enough width for container */
}

.qr-container {
    width: 125px;
    /* Increased size based on image_1.png */
    height: 125px;
    /* Increased size based on image_1.png */
    border: 2px solid var(--border-color);
    position: relative;
    padding: 3px;
    margin: 0 auto 8px auto;
    /* Center horizontally */
    background: #fff;
}

.qr-container img {
    width: 100%;
    height: 100%;
    display: block;
}

.qr-shop-name {
    font-weight: 700;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.footer-right {
  width: 60%;
}

.totals-table {
  width: 100%;
  border: none;
  border-collapse: separate;
  border-spacing: 0 4px;
  margin-bottom: 15px;
}

.totals-table td {
  border: none;
  padding: 2px 0;
}

.totals-table .label {
  text-align: left;
  font-weight: 600;
  font-size: 11px;
}

.amount-cell {
  text-align: right;
  width: 100px;
}

.amount-container {
  border-bottom: 1px solid #ccc;
  min-width: 100px;
  display: inline-block;
  text-align: right;
  font-weight: 600;
}

.grand-total {
  font-weight: 700;
  font-size: 13px;
  color: #e34133;
}

.totals-table .grand-total.label {
    font-size: 13px;
}

.terms-section {
  margin-top: 10px;
}

.terms-title {
  font-weight: 700;
  font-size: 13px;
  margin-bottom: 5px;
}

.terms-list {
  font-size: 12px;
  line-height: 1.5;
  margin: 0;
  padding: 0;
  list-style: none;
}

.terms-list li {
  margin-bottom: 2px;
  padding-left: 10px;
  position: relative;
}

.terms-list li::before {
  content: "•";
  position: absolute;
  left: 0;
}
</style>
